export default __webpack_public_path__ + "static/media/mobileMockup.f5703973.png";